<template>
  <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      fullscreen
      scrollable
  >
    <v-card height="80%" v-if="product">
      <v-row class="ma-0" style="max-height: 50px;">
        <v-col cols="1">
          <v-btn small tile icon @click="$emit('close')">
            <v-icon color="primary" v-if="!editing">
              $chevronDown
            </v-icon>
            <v-icon color="primary" v-else>
              $chevronLeft
            </v-icon>
          </v-btn>
        </v-col>

        <v-col cols="7">
          <p class="text-truncate text-subtitle-1 font-weight-medium ma-0" v-text="product.name" />
        </v-col>

        <v-col cols="4" align="right">
          <p class="text-subtitle-1 primary--text font-weight-medium ma-0" v-text="productPrice(product, '')" />
        </v-col>
      </v-row>

      <v-card-text class="pa-0" id="card-configure-product">
        <v-img
            v-if="configs.show_image"
            height="160"
            width="160"
            class="card-image mx-auto rounded-lg"
            :src="product.image"
        />

        <v-card-subtitle v-text="product.description" class="pt-2" />

        <combo v-if="isCombo" :data="data" />
        <product v-else :data="data" />
      </v-card-text>

      <v-card class="text-center pa-3" v-if="configs.enable_order && this.data.form">
        <v-row>
          <v-col cols="4" align-self="center">
            <v-btn
                color="primary"
                icon
                tile
                small
                @click="minusAmount"
                :disabled="data.form.amount === 1"
              >
              <v-icon>$minus</v-icon>
            </v-btn>
            <span class="mx-1" v-text="data.form.amount"></span>
            <v-btn
                color="primary"
                icon
                tile
                small
                @click="plusAmount"
              ><v-icon>$plus</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="8">
            <v-btn :loading="loading" color="primary" @click="addProductCart" x-large block
                   :disabled="!data.form.canBeAddedToCart"
            >
              {{`${editing ? 'Alterar' : 'Adicionar'} (${formatMoney(data.form.total_value)})`}}
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import {useGlobalCart} from '../../../store/store'
import _ from "lodash";
import ConfigureProduct from "./ConfigureProduct";
import Product from './Details/Product';
import Combo from './Details/Combo';

export default {
  name: "InfoProduct",
  props: {
    dialog: {
      required: true,
      default: false
    },
    product: {
      required: true,
      default: null
    },
    editing: {
      required: false,
      type: Boolean,
      default: false
    },
    cartProduct: {
      required: false
    }
  },
  components: {
    ConfigureProduct,
    Product,
    Combo
  },
  data: () => ({
    data: {
      form: null,
      type: null,
      editing: false
    },
    loading: false,
    tab: null,
  }),
  setup() {
    const state = useGlobalCart()
    const configs = _config.functionalities.digitalmenu.configs

    return { state, configs }
  },
  methods: {
    setupForm() {
      this.data.form = {product: this.product}
      this.data.editing = this.editing
      this.data.type = this.indexByCompositionType

      if (this.editing) {
        this.data.form = this.cartProduct
      }
    },
    addProductCart() {
      this.loading = true
      let indexByType = this.indexByCompositionType

      if (!this.state.unique_id) {
        this.state.unique_id = this.generateUuid()
        this.state.sale_start = this.dateFormat()
      }

      if (!this.editing) {
        let productIndexCart = -1;

        //Se o novo produto não possui adicionais, procure um produto no carrinho igual
        if (!this.data.form.additionals?.length) {
          productIndexCart = this.state[indexByType].findIndex(product => product.id === this.data.form.id && !product.additionals?.length)
        } else {
          productIndexCart = this.state[indexByType].findIndex(product => product.id === this.data.form.id)
        }

        // Se o mesmo produto está no carrinho acrescente o amount, atualize o total_value do produto e
        // adicione a observacao no array de observações assim como é no PDV.
        if (!this.data.form.attributes && productIndexCart >= 0 && !this.isCombo) {
          // Verificar se os produtos, novo e existente, possuem adicionais.
          // Se qualquer um possuir, um novo produto será adicionado ao invés de atualizar o existente.
          if (this.state[indexByType][productIndexCart].additionals?.length || this.data.form.additionals?.length) {
            this.state[indexByType].push(this.data.form)
          } else {
            this.state[indexByType][productIndexCart].amount += this.data.form.amount
            this.state[indexByType][productIndexCart].total_value += this.data.form.total_value

            if (this.data.form.observation?.length) {
              this.state[indexByType][productIndexCart].observation.push(this.data.form.observation[0])
            }
          }
        } else {
          this.state[indexByType].push(this.data.form)
        }

        this.state.tax_value = _.sumBy(this.state.products, 'tax_value') + _.sumBy(this.state.combos, 'tax_value')
        this.state.total_value += this.data.form.total_value + this.state.tax_value

        this.$emit('productadded')
      }

      this.loading = false
      this.$emit('close')
    },
    canBeAdded () {
      if (this.isCombo) {
        this.data.form.canBeAddedToCart = this.data.form.products?.filter(product => !product.canBeAddedToCart).length <= 0
      }
    },
    minusAmount () {
      this.data.form.amount -= 1
      this.data.form.total_value = this.formatValue(this.data.form.unitary_value * this.data.form.amount)
    },
    plusAmount () {
      this.data.form.amount += 1
      this.data.form.total_value = this.formatValue(this.data.form.unitary_value * this.data.form.amount)
    },
    calculateTotal () {
      this.canBeAdded()
    }
  },
  computed: {
    indexByCompositionType () {
      return this.isCombo ? 'combos' : 'products'
    },
    isCombo () {
      return this.product?.composition_type === 1
    }
  },
  watch: {
    'product' (newV, oldV) {
      if (newV) {
        this.setupForm()
      }
    },
    'data.form': {
      handler(newValue) {
        if (newValue) {
          this.calculateTotal()
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
  .text-clamp {
    font-size: 13px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .attribute-title {
    span {
      line-height: 1.4rem !important;
    }
  }

  .attribute-subtitle {
    font-size: 0.7rem !important;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance:textfield;
  }

  .sticky {
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .v-btn.v-size--x-large {
    font-size: .910rem !important;
 }
</style>